import React from "react";
import "../css/AfterHoursTiming.css";
import { getTimezoneString } from "../../../utils/dateUtils";

const AfterHoursTiming = ({ tripData, timingInfo }) => {
  
  return (
    <div className="after-hours-timings-container">
      After Hours Requested
      <div className="after-hours-timings-information">
        <p>
          <strong>Airport Timings: </strong>
          {tripData?.requiresDepartureOvertime
            ? `${timingInfo.openingTime} to ${
                timingInfo.scheduledTime
              }  (${getTimezoneString()})`
            : `${timingInfo.openingTime} to ${
                timingInfo.scheduledTime
              } (${getTimezoneString()})`}
        </p>
        <p>
          <strong>Total After Hours:</strong>
          {timingInfo.durationDifferenceInHours} hrs
        </p>
      </div>
    </div>
  );
};

export default AfterHoursTiming;
